/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApproveBillingPerUnitPropertiesAttributes } from '../models/ApproveBillingPerUnitPropertiesAttributes';
import type { ApproveBillingPerUnitPropertyOffboardingAttributes } from '../models/ApproveBillingPerUnitPropertyOffboardingAttributes';
import type { BackfillBillingPerUnitPropertyAttributes } from '../models/BackfillBillingPerUnitPropertyAttributes';
import type { BackfillCentralizedBillingPropertyAttributes } from '../models/BackfillCentralizedBillingPropertyAttributes';
import type { ControllerResponse_BillingPerUnitInfoAttributes_ } from '../models/ControllerResponse_BillingPerUnitInfoAttributes_';
import type { ControllerResponse_BillingPerUnitInfoAttributes_Array_ } from '../models/ControllerResponse_BillingPerUnitInfoAttributes_Array_';
import type { ControllerResponse_BillingPerUnitPropertyAttributes_ } from '../models/ControllerResponse_BillingPerUnitPropertyAttributes_';
import type { ControllerResponse_BillingPerUnitPropertyAttributes_Array_ } from '../models/ControllerResponse_BillingPerUnitPropertyAttributes_Array_';
import type { ControllerResponse_BillingPerUnitStripePreview_ } from '../models/ControllerResponse_BillingPerUnitStripePreview_';
import type { ControllerResponse_boolean_ } from '../models/ControllerResponse_boolean_';
import type { ControllerResponse_SubscriptionBackfillPreview_ } from '../models/ControllerResponse_SubscriptionBackfillPreview_';
import type { ControllerResponse_ValidateOrganizationMemberResult_ } from '../models/ControllerResponse_ValidateOrganizationMemberResult_';
import type { CreateBillingPerUnitInfoAttributes } from '../models/CreateBillingPerUnitInfoAttributes';
import type { CreateBillingPerUnitPropertyAttributes } from '../models/CreateBillingPerUnitPropertyAttributes';
import type { CreateDecentralizedChildAttributes } from '../models/CreateDecentralizedChildAttributes';
import type { UpdateBillingPerUnitInfoAttributes } from '../models/UpdateBillingPerUnitInfoAttributes';
import type { UpdateBillingPerUnitPropertyAttributes } from '../models/UpdateBillingPerUnitPropertyAttributes';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BillingService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Lists an organization's per-unit properties.
     * @param organizationId
     * @returns ControllerResponse_BillingPerUnitPropertyAttributes_Array_ Ok
     * @throws ApiError
     */
    public listProperties(
        organizationId: number,
    ): CancelablePromise<ControllerResponse_BillingPerUnitPropertyAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/billing/per_unit/organization/{organizationId}/properties',
            path: {
                'organizationId': organizationId,
            },
        });
    }
    /**
     * Adds a property to a centralized billing account.
     * @param organizationId
     * @param requestBody
     * @returns ControllerResponse_BillingPerUnitPropertyAttributes_ Ok
     * @throws ApiError
     */
    public createProperty(
        organizationId: number,
        requestBody: CreateBillingPerUnitPropertyAttributes,
    ): CancelablePromise<ControllerResponse_BillingPerUnitPropertyAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/billing/per_unit/organization/{organizationId}/properties',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Approves pending property onboarding requests.
     * @param organizationId
     * @param requestBody
     * @returns ControllerResponse_BillingPerUnitPropertyAttributes_Array_ Ok
     * @throws ApiError
     */
    public approveProperties(
        organizationId: number,
        requestBody: ApproveBillingPerUnitPropertiesAttributes,
    ): CancelablePromise<ControllerResponse_BillingPerUnitPropertyAttributes_Array_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/billing/per_unit/organization/{organizationId}/properties/approve',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Approves pending property offboarding requests.
     * @param organizationId
     * @param requestBody
     * @returns ControllerResponse_BillingPerUnitPropertyAttributes_Array_ Ok
     * @throws ApiError
     */
    public approvePropertyOffboarding(
        organizationId: number,
        requestBody: ApproveBillingPerUnitPropertyOffboardingAttributes,
    ): CancelablePromise<ControllerResponse_BillingPerUnitPropertyAttributes_Array_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/billing/per_unit/organization/{organizationId}/properties/approve_offboarding',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Cancels a pending property offboarding request.
     * @param organizationId
     * @param propertyBillingId
     * @returns ControllerResponse_BillingPerUnitPropertyAttributes_ Ok
     * @throws ApiError
     */
    public cancelPropertyOffboarding(
        organizationId: number,
        propertyBillingId: number,
    ): CancelablePromise<ControllerResponse_BillingPerUnitPropertyAttributes_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/billing/per_unit/organization/{organizationId}/properties/{propertyBillingId}/cancel_offboarding',
            path: {
                'organizationId': organizationId,
                'propertyBillingId': propertyBillingId,
            },
        });
    }
    /**
     * Creates a property under a decentralized billing account.
     * @param organizationId
     * @param requestBody
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public createDecentralizedChild(
        organizationId: number,
        requestBody: CreateDecentralizedChildAttributes,
    ): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/billing/per_unit/organization/{organizationId}/decentralized_child',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param organizationId
     * @param propertyBillingId
     * @param requestBody
     * @returns ControllerResponse_BillingPerUnitPropertyAttributes_ Ok
     * @throws ApiError
     */
    public updateProperty(
        organizationId: number,
        propertyBillingId: number,
        requestBody: UpdateBillingPerUnitPropertyAttributes,
    ): CancelablePromise<ControllerResponse_BillingPerUnitPropertyAttributes_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/billing/per_unit/organization/{organizationId}/properties/{propertyBillingId}',
            path: {
                'organizationId': organizationId,
                'propertyBillingId': propertyBillingId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Deletes or offboards a per-unit property.
     * @param organizationId
     * @param propertyBillingId
     * @returns ControllerResponse_BillingPerUnitPropertyAttributes_ Ok
     * @throws ApiError
     */
    public deleteProperty(
        organizationId: number,
        propertyBillingId: number,
    ): CancelablePromise<ControllerResponse_BillingPerUnitPropertyAttributes_> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/billing/per_unit/organization/{organizationId}/properties/{propertyBillingId}',
            path: {
                'organizationId': organizationId,
                'propertyBillingId': propertyBillingId,
            },
        });
    }
    /**
     * Validates an organization member for decentralized billing.
     * @param organizationId
     * @param email
     * @returns ControllerResponse_ValidateOrganizationMemberResult_ Ok
     * @throws ApiError
     */
    public validateOrganizationMember(
        organizationId: number,
        email: string,
    ): CancelablePromise<ControllerResponse_ValidateOrganizationMemberResult_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/billing/per_unit/organization/{organizationId}/validate/member',
            path: {
                'organizationId': organizationId,
            },
            query: {
                'email': email,
            },
        });
    }
    /**
     * Records an existing centralized property without changing Stripe billing.
     * @param organizationId
     * @param requestBody
     * @returns ControllerResponse_BillingPerUnitPropertyAttributes_ Ok
     * @throws ApiError
     */
    public backfillCentralizedProperty(
        organizationId: number,
        requestBody: BackfillCentralizedBillingPropertyAttributes,
    ): CancelablePromise<ControllerResponse_BillingPerUnitPropertyAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/billing/per_unit/organization/{organizationId}/properties/backfill_centralized',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Backfills a property from a Stripe subscription.
     * @param organizationId
     * @param requestBody
     * @returns ControllerResponse_BillingPerUnitPropertyAttributes_ Ok
     * @throws ApiError
     */
    public backfillProperty(
        organizationId: number,
        requestBody: BackfillBillingPerUnitPropertyAttributes,
    ): CancelablePromise<ControllerResponse_BillingPerUnitPropertyAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/billing/per_unit/organization/{organizationId}/properties/backfill',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Previews a Stripe subscription for property backfill.
     * @param organizationId
     * @param subscriptionId
     * @returns ControllerResponse_SubscriptionBackfillPreview_ Ok
     * @throws ApiError
     */
    public fetchSubscriptionPreview(
        organizationId: number,
        subscriptionId: string,
    ): CancelablePromise<ControllerResponse_SubscriptionBackfillPreview_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/billing/per_unit/organization/{organizationId}/subscription_preview/{subscriptionId}',
            path: {
                'organizationId': organizationId,
                'subscriptionId': subscriptionId,
            },
        });
    }
    /**
     * Previews Stripe billing data used to backfill missing HelloData billing information.
     * @param organizationId
     * @returns ControllerResponse_BillingPerUnitStripePreview_ Ok
     * @throws ApiError
     */
    public stripePreview(
        organizationId: number,
    ): CancelablePromise<ControllerResponse_BillingPerUnitStripePreview_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/billing/per_unit/organization/{organizationId}/stripe_preview',
            path: {
                'organizationId': organizationId,
            },
        });
    }
    /**
     * Lists HelloData billing information enriched with current pricing from Stripe.
     * @param organizationId
     * @returns ControllerResponse_BillingPerUnitInfoAttributes_Array_ Ok
     * @throws ApiError
     */
    public listBillingInfo(
        organizationId: number,
    ): CancelablePromise<ControllerResponse_BillingPerUnitInfoAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/billing/per_unit/organization/{organizationId}/info',
            path: {
                'organizationId': organizationId,
            },
        });
    }
    /**
     * Creates an organization's per-unit billing information.
     * @param organizationId
     * @param requestBody
     * @returns ControllerResponse_BillingPerUnitInfoAttributes_ Ok
     * @throws ApiError
     */
    public createBillingInfo(
        organizationId: number,
        requestBody: CreateBillingPerUnitInfoAttributes,
    ): CancelablePromise<ControllerResponse_BillingPerUnitInfoAttributes_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/billing/per_unit/organization/{organizationId}/info',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Updates an organization's per-unit billing information.
     * @param organizationId
     * @param infoId
     * @param requestBody
     * @returns ControllerResponse_BillingPerUnitInfoAttributes_ Ok
     * @throws ApiError
     */
    public updateBillingInfo(
        organizationId: number,
        infoId: number,
        requestBody: UpdateBillingPerUnitInfoAttributes,
    ): CancelablePromise<ControllerResponse_BillingPerUnitInfoAttributes_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/billing/per_unit/organization/{organizationId}/info/{infoId}',
            path: {
                'organizationId': organizationId,
                'infoId': infoId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
